const SkeletonCard = () => {
    return (
        <div className="w-[170px] h-[230px] bg-white animate-pulse rounded-lg mx-2">
            <div className="w-[170px]"></div>
        </div>
    )
}

export default SkeletonCard